<template  >
  <div >
   
    <div class="buscador">
      <label for="search">Buscar</label>
      <input type="text" v-model="searchTerm" @input="buscarCartas" id="search" />
    </div>
    <div >
  <table id="tabla-edicion">
    <tr>
      <th>
      Principio Activo
      </th>
      <th>
      Nombre Comercial
      </th>
      <th>
      Asunto
      </th>
      <th>
      Fecha
      </th>
 
    </tr>
    <tr v-for="cartas in cartasMostradas" :key="cartas.id">
      <td v-if="cartas">
        {{ cartas.principioActivo }}
      </td>
      <td>
        {{ cartas.nombreComercial }}
      </td>
      <td>
        <a :href="'/PDF/' + cartas.rutaPDF" target="_blank">{{ cartas.asunto }}</a>
      </td>
      <td>
        {{ cartas.fecha }}
      </td>
     
    </tr>
  
</table>
<div class="paginacion">
      <button @click="anteriorPagina" :disabled="paginaActual === 1" class="paginacion-btn">Anterior</button>
      <span class="paginacion-actual">Página {{ paginaActual }}</span>
      <button @click="siguientePagina" :disabled="paginaActual === totalPaginas" class="paginacion-btn">Siguiente</button>
    </div>
      </div>
    </div>

 

</template>

<script>


export default {
  props: {
  showHeader: {
    type: Boolean,
    default: true,
  },},
  data() {
    return {
      cartas: [],
      cartasFiltradas: [],
      searchTerm: "",
      paginaActual: 1,
      cartasPorPagina: 10,
    };
  },

  created: function () {
    this.consultarCartas();

  },
  methods: {
    consultarCartas() {
      fetch("/php/mostrar.php")
        .then((respuesta) => respuesta.json())
        .then((datosRespuesta) => {
         
          this.cartas = [];
          if (typeof datosRespuesta[0].success === "undefined") {
            this.cartas = datosRespuesta;
            this.filtrarCartas();
          }
        })
        .catch();
    },
    
    buscarCartas() {
      this.paginaActual = 1;
      this.filtrarCartas();
    },
    filtrarCartas() {
      this.cartasFiltradas = this.cartas.filter((carta) => {
        const termino = this.searchTerm.toLowerCase();
        return (
          carta.principioActivo.toLowerCase().includes(termino) ||
          carta.nombreComercial.toLowerCase().includes(termino) ||
          carta.asunto.toLowerCase().includes(termino) ||
          carta.fecha.toLowerCase().includes(termino)
        );
      });
    },
    anteriorPagina() {
  if (this.paginaActual > 1) {
    this.paginaActual--;
  }
},
siguientePagina() {
  if (this.paginaActual < this.totalPaginas) {
    this.paginaActual++;
  }
},

  },
  computed: {
  totalPaginas() {
    return Math.ceil(this.cartasFiltradas.length / this.cartasPorPagina);
  },
  cartasMostradas() {
    const cartasInvertidas = [...this.cartasFiltradas].reverse();
      const inicio = (this.paginaActual - 1) * this.cartasPorPagina;
      const fin = inicio + this.cartasPorPagina;

      return cartasInvertidas.slice(inicio, fin);
    },
},
};
</script>
  <style scoped>
.hide-header {
  display: none;
  }

</style>